<template>
  <!--  横向 Item  -->
  <div class="item_div" :style="{'width':(1/item_num)*(100-item_num*2)+'%'}" @click="to_datail(id)">
    <el-image
      style="width: 100%; height: 42vh"
      :src="image_url"
      fit="cover"/>
    <div class="font_div">
      <p class="title_div">
        {{ title_txt }}
      </p>
      <p class="content_div">
        {{ content_txt }}
      </p>
      <div class="more_div">
        <label class="more_label">more</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'list_item_column',
  props:{
    'item_num':{
      type:String,
      require:false,
      default:1
    },
    'id': {    //详情Id
      type:Number,
      require: true,
      default: 0
    },
    'image_url': {    //图片的地址
      type:String,
      require: false,
      default:''
    },
    'title_txt':{   //标题
      type:String,
      require: false,
      default:'标题'
    },
    'content_txt':{   //简述
      type:String,
      require: false,
      default:'简介'
    },
  },
  methods:{
    /**
     * 跳转到详情页面
     */
    to_datail(id_val){
      this.$router.push({path: '/secth/detail', query: {id:id_val}})
    }
  }

}
</script>

<style scoped lang="scss">

.item_div{
  background: white;
  cursor: pointer;
  overflow: hidden;
  float: left;
  margin-left: 1%;
  margin-right: 1%;
}

.font_div{
  text-align: left;
  padding: 20px;
}
.title_div{
  font-size: 16pt;
  font-weight: 300;
  color: #009CD5;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;-webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.content_div{
  font-size: 12pt;
  font-weight: 300;
  color: #666666;
  line-height: 35px;
  height: 105px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;-webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.more_label {
  color: #009CD5;
}

.more_div {
  text-align: right;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/list_item_column.vue